import { Reveal } from "@/components/common/Reveal";

export const About = () => (
    <section
        id="qui-sommes-nous"
        data-testid="about-section"
        className="relative bg-white py-24 lg:py-32 px-6 md:px-12 scroll-mt-24"
    >
        <div className="mx-auto max-w-[1400px]">
            <div className="grid gap-12 lg:grid-cols-12 lg:gap-20 items-center">
                <div className="lg:col-span-5">
                    <Reveal>
                        <div className="relative">
                            <div className="overflow-hidden rounded-[2rem] max-h-[78vh]">
                                <img
                                    src="/images/founder.jpg"
                                    alt="Laurie-Line Rozier, fondatrice de ROZIER CONCEPT"
                                    className="h-full w-full object-cover aspect-[4/5] transition-transform [transition-duration:1200ms] hover:scale-105"
                                />
                            </div>
                            <div className="absolute -bottom-6 -right-2 md:right-6 rounded-2xl bg-rz-green px-6 py-5 text-white shadow-2xl shadow-rz-green/30">
                                <p className="font-display text-lg font-bold leading-tight">
                                    Laurie-Line Rozier
                                </p>
                                <p className="text-xs text-rz-pale mt-1">
                                    Fondatrice &amp; bâtisseuse
                                </p>
                            </div>
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-7">
                    <Reveal>
                        <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                            Qui sommes-nous
                        </span>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-5 text-[clamp(1.9rem,4vw,3rem)] font-bold tracking-tight leading-[1.08] text-rz-ink">
                            Bâtisseuse en écoconstruction, géobiologue et paysagiste.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <div className="mt-7 space-y-5 text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                            <p>
                                Passionnée depuis toujours par le bâti, le paysage et l'équilibre
                                des lieux, j'ai développé une approche sensible, réfléchie et
                                cohérente de l'habitat et de son environnement.
                            </p>
                            <p>
                                La Méthode Rozier s'appuie sur des connaissances intenses, des
                                formations et certifications issues de différents corps de métiers,
                                dont la géobiologie appliquée et l'ossature bois.
                            </p>
                            <p>
                                Entourée d'une équipe d'artisans passionnés, ROZIER CONCEPT, agricole
                                et haras, met tout en oeuvre pour construire des lieux qui produisent,
                                protègent et transmettent. Le bien-être animal constitue le fondement
                                de notre démarche.
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.26}>
                        <div className="mt-10 grid grid-cols-3 gap-6 border-t border-black/5 pt-8">
                            {[
                                { k: "100%", v: "Sur mesure" },
                                { k: "France", v: "Partout" },
                                { k: "Durable", v: "Écoconstruction" },
                            ].map((s) => (
                                <div key={s.v} data-testid={`about-stat-${s.v}`}>
                                    <p className="font-display text-2xl md:text-3xl font-extrabold text-rz-green">
                                        {s.k}
                                    </p>
                                    <p className="mt-1 text-xs md:text-sm text-rz-ink-soft">
                                        {s.v}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
